/* global Waypoint */

'use strict';

import '/node_modules/waypoints/lib/noframework.waypoints.js';

/**
 * In view class.
 */
class InView {
    /**
     * Construct.
     * @param el
     * @param options
     */
    constructor(el, options = {
        offset: '95%',
        cssClass: 'fade-in',
    }) {
        this._settings = options;

        el.classList.add(this._settings.cssClass);

        new Waypoint({
            element: el,
            handler: this.getApplyFunction(),
            offset: this._settings.offset,
        });
    }

    /**
     * Apply class to elements.
     * @param direction
     */
    getApplyFunction() {
        let inViewClass = `${this._settings.cssClass}--in-view`;

        return function(direction) {
            if (direction === 'down') {
                this.element.classList.add(inViewClass);
            }
        };
    }
}

export default InView;
